import { useMemo } from 'react';
import {
  ConversationThreadEntityType,
  IConversationEntityFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../utils/types';
import { analysisSelector } from '../../../../redux/selectors/analyses';
import { useAppSelector } from '../../../../redux/hooks';

interface IProps {
  entity: IConversationEntityFieldsFragment;
}

const ReportThreadHeading = ({ entity }: IProps) => {
  assertCondition(entity.type === ConversationThreadEntityType.Analysis);
  const currentAnalysisMemoizedSelector = useMemo(analysisSelector, []);
  const currentAnalysis = useAppSelector((state) =>
    currentAnalysisMemoizedSelector(state, entity.id),
  );

  // In Dashboard comments we want to reflect a report name for Report threads
  // Though, there is a report loading queue so while report is loading - use
  // a placeholder
  return <>{currentAnalysis?.metadata?.display ?? 'Report'}</>;
};

export default ReportThreadHeading;
